import { mainAPI, handleApiError } from "../api";

import {
  CommentsRequest,
  CommentResponse,
  EntityType,
} from "../types/api/comments";
import { ApiErrorResponse } from "../types/api/error";

const path = `/interactions/admin/${process.env.REACT_APP_API_VERSION}/comments`;

// Комментарий - Получить запись
export function fetchComment(id: string) {
  const url = `/interactions/${process.env.REACT_APP_API_VERSION}/comments`;

  return mainAPI.get(`${url}/${id}`).then(
    (res) => {
      return Promise.resolve(res.data as CommentResponse);
    },
    (error) => handleApiError(error)
  );
}

// Комментарии - Получить список
export function fetchComments(params: CommentsRequest) {
  const { entity_id, entity_type, ...queryParams } = params;
  return mainAPI
    .get<CommentResponse[]>(`${path}/entity/${entity_type}/${entity_id}`, {
      params: queryParams,
    })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}

// Комментарии - Получить древовидный список
export function fetchCommentsAsTree(params: CommentsRequest) {
  const { entity_id, entity_type, ...queryParams } = params;

  return mainAPI
    .get<CommentResponse[]>(`${path}/entity/${entity_type}/${entity_id}/tree`, {
      params: queryParams,
    })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}

// Комментарии для сущностей - Экспортировать
export function exportComments(
  entity_id: string,
  entity_type: EntityType,
  is_admin: boolean
) {
  return mainAPI
    .get(
      `${path}/entity/${entity_type}/${entity_id}/export?is_admin=${is_admin}`,
      {
        responseType: "blob",
      }
    )
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Ошибка при экспорте комментариев")
        );
      }
    );
}

// Комментарий - Удалить
export function deleteComment(uuids: string[]) {
  return mainAPI.post(`${path}/delete`, { uuids: uuids }).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}
